import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "debug-content" }
const _hoisted_2 = { class: "control-group" }
const _hoisted_3 = { class: "control-group" }
const _hoisted_4 = { class: "control-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["debug-panel", { 'is-open': _ctx.isOpen }])
  }, [
    _createElementVNode("button", {
      class: "debug-toggle",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.togglePanel && _ctx.togglePanel(...args)))
    }, "调试"),
    _createElementVNode("div", _hoisted_1, [
      _cache[9] || (_cache[9] = _createElementVNode("h3", null, "滚动视图调试", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", null, "左列速度: " + _toDisplayString(_ctx.leftSpeed) + "s", 1),
        _withDirectives(_createElementVNode("input", {
          type: "range",
          min: "20",
          max: "120",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.leftSpeed) = $event)),
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateSpeed('left')))
        }, null, 544), [
          [_vModelText, _ctx.leftSpeed]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, "中列速度: " + _toDisplayString(_ctx.middleSpeed) + "s", 1),
        _withDirectives(_createElementVNode("input", {
          type: "range",
          min: "20",
          max: "120",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.middleSpeed) = $event)),
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateSpeed('middle')))
        }, null, 544), [
          [_vModelText, _ctx.middleSpeed]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", null, "右列速度: " + _toDisplayString(_ctx.rightSpeed) + "s", 1),
        _withDirectives(_createElementVNode("input", {
          type: "range",
          min: "20",
          max: "120",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.rightSpeed) = $event)),
          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateSpeed('right')))
        }, null, 544), [
          [_vModelText, _ctx.rightSpeed]
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.pauseAll && _ctx.pauseAll(...args))),
        class: "control-button"
      }, _toDisplayString(_ctx.isPaused ? '恢复滚动' : '暂停滚动'), 1),
      _createElementVNode("button", {
        onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.resetSpeeds && _ctx.resetSpeeds(...args))),
        class: "control-button"
      }, "重置速度")
    ])
  ], 2))
}